import { render, staticRenderFns } from "./DeleteProgramModal.vue?vue&type=template&id=f5018a40"
import script from "./DeleteProgramModal.vue?vue&type=script&lang=ts"
export * from "./DeleteProgramModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports